import MoreVertIcon from '@mui/icons-material/MoreVert'
import { IconButton } from '@mui/material'
import { MouseEvent, useRef, useState } from 'react'
import { IMoreTableItem, MorePopover } from './MorePopover'

interface IMoreTableButtonProps {
  items: IMoreTableItem[]
}

const MoreTableButton = ({ items }: IMoreTableButtonProps) => {
  const [open, setOpen] = useState(false)
  const anchorRef = useRef<HTMLButtonElement>(null)

  const handleOpen = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    setOpen(true)
  }
  const handleClose = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    setOpen(false)
  }

  return (
    <>
      <IconButton ref={anchorRef} onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <MorePopover items={items} anchorRef={anchorRef} handleClose={handleClose} open={open} />
    </>
  )
}

export { MoreTableButton }
